import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full p-4 flex flex-col justify-center space-y-3 overflow-hidden" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = { class: "space-y-1.5" }
const _hoisted_4 = { class: "flex justify-between items-center text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_5 = { class: "w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'StepOneAnimation',
  props: {
    isHovering: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const sliderWidth = computed(() => (props.isHovering ? "100%" : "0%"));
const weeks = computed(() => (props.isHovering ? 12 : 0));

return (_ctx: any,_cache: any) => {
  const _component_UIcon = _resolveComponent("UIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["p-3 rounded-lg border flex items-center justify-between transition-all duration-300", __props.isHovering ? 'border-green-500/50' : 'border-gray-200 dark:border-gray-700/50'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center transition-colors duration-300 shrink-0", __props.isHovering ? 'bg-green-400' : 'bg-gray-300 dark:bg-gray-600'])
        }, [
          _createVNode(_component_UIcon, {
            name: "i-heroicons-user",
            class: "text-white dark:text-gray-900 text-lg"
          })
        ], 2),
        _cache[0] || (_cache[0] = _createElementVNode("div", null, [
          _createElementVNode("div", { class: "w-20 h-2 rounded-full bg-gray-300 dark:bg-gray-600 mb-1" }),
          _createElementVNode("div", { class: "w-12 h-2 rounded-full bg-gray-300/70 dark:bg-gray-600/70" })
        ], -1))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["w-9 h-5 flex items-center rounded-full transition-colors duration-300", __props.isHovering ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-4 h-4 m-0.5 bg-white rounded-full transition-transform duration-300 ease-in-out", { 'translate-x-4': __props.isHovering }])
        }, null, 2)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Assessment Duration", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["font-semibold text-gray-800 dark:text-gray-200 transition-opacity duration-300", __props.isHovering ? 'opacity-100' : 'opacity-0'])
        }, _toDisplayString(weeks.value) + " weeks ", 3)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "bg-indigo-500 h-1.5 rounded-full transition-all duration-700 ease-out",
          style: _normalizeStyle({ width: sliderWidth.value })
        }, null, 4)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["w-full text-center py-2 rounded-lg transition-all duration-500 text-sm", 
          __props.isHovering
            ? 'bg-indigo-500 text-white shadow-md'
            : 'bg-gray-200 dark:bg-gray-700 text-transparent'
        ])
      }, " Start Assessment ", 2)
    ])
  ]))
}
}

})